import isMobile from "./isMobile";

const $ = jQuery.noConflict();

export default function fancyboxInit() {
    $("[data-fancybox]").fancybox({
        loop: true,
        baseClass: "fancybox-gallery",
    });

    if (isMobile()) {
        $("[data-fancybox-mobile]").fancybox();
    }
}
